<template>
  <div class="fill-height mouse-cursor">
    <v-container v-if="loading" fill-height>
      <v-row>
        <v-col>
          <v-progress-circular indeterminate />
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="attempt" fill-height>
      <v-row justify="center" align="center" class="pa-4 pa-sm-8">
        <v-col cols="12" md="9">
          <v-card flat class="pa-4">
            <!--gif image-->
            <v-row justify="center" align="center">
              <v-img
                v-if="isPassed"
                src="@/app/course-module/assets/images/congrats.gif"
                :alt="$t('course.congratulations')"
                max-width="250"
                cover
              >
              </v-img>

              <v-col v-else></v-col>
            </v-row>

            <!--congrats-->
            <v-row justify="center" align="center">
              <v-col>
                <span class="text-h4 font-weight-bold textLight--text">
                  {{ isPassed ? $t("course.congratulations") : "" }}!
                </span>
              </v-col>
            </v-row>

            <!--congrats message-->
            <v-row justify="center" align="center" class="mb-4">
              <v-col>
                <p class="subtitle-2 textLight--text ma-0">
                  {{
                    isPassed
                      ? $t("quiz.quizPassedMessage")
                      : $t("quiz.quizFailedMessage")
                  }}
                </p>

                <p
                  v-if="attempt.quizContent"
                  class="subtitle-2 textLight--text ma-0"
                >
                  "{{ getLocalisedValue(attempt.quizContent.title) }}"
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else class="fill-height">
      <Error />
    </v-container>
  </div>
</template>

<script>
import Error from "../../core-module/components/Error";

export default {
  name: "AssessmentAttemptDetailsPage",
  components: {
    Error,
  },
  data() {
    return {
      loading: true,
      attempt: null,
    };
  },
  computed: {
    isPassed() {
      return this.attempt.attempt.status === "PASSED";
    },
  },
  created() {
    if (this.$route.params.attempt) {
      this.attempt = this.$route.params.attempt;
      this.loading = false;
    } else if (this.$route.params.id) {
      this.$apollo.addSmartQuery("getQuizAttempt", {
        query: require("../api/query/getQuizAttempt.gql"),
        variables: { id: this.$route.params.id },
        result({ data, loading }) {
          if (data?.getQuizAttempt) {
            this.attempt = data.getQuizAttempt;
          }

          this.loading = loading;
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped />
